import firebase from 'firebase/app'
import format from 'date-fns/format'
import { globalfunc } from '../../globalfunc.js'
import { getBossTeamId, shouldAutoSetParent } from '../../utils/teamParent'

export const findTeamByName = (teamMaster: any, teamName: string) => {
  if (!teamMaster || !teamName) return ''
  const normalized = teamName.toLowerCase()
  return Object.keys(teamMaster).find((key) => {
    const item = teamMaster[key]
    return item && item.name && item.name.toLowerCase() === normalized
  }) || ''
}

export const maybeAutoSetTeamParent = async (args: {
  allUser: any,
  teamMaster: any,
  teamId: string,
  userOverrides: Record<string, { team: string, boss: string }>,
}) => {
  const currentParent = (args.teamMaster[args.teamId] && args.teamMaster[args.teamId].parent) ? args.teamMaster[args.teamId].parent : ''
  const parentDecision = shouldAutoSetParent({
    allUser: args.allUser,
    teamId: args.teamId,
    currentParent,
    userOverrides: args.userOverrides,
  })
  if (!parentDecision.shouldUpdate || !parentDecision.parentId || args.teamId === parentDecision.parentId) {
    return false
  }
  await firebase.database().ref(`team/${args.teamId}`).update({
    parent: parentDecision.parentId,
    updated: format(new Date(), 'YYYY-MM-DD HH:mm'),
  })
  return true
}

export const createTeamWithBossParent = async (args: {
  teamName: string,
  bossEmail: string,
  allUser: any,
  company: string,
}) => {
  const parentId = getBossTeamId(args.allUser, args.bossEmail)
  const teamId = firebase.database().ref('team').push().key as string
  await firebase.database().ref(`team/${teamId}`).update({
    name: args.teamName,
    parent: parentId,
    company: args.company,
    internal_id: 't' + globalfunc.generateRandomNumber(),
    updated: format(new Date(), 'YYYY-MM-DD HH:mm'),
  })
  return teamId
}
